import React from 'react';

const Header = () => {
  return (
    <header>
      <img src="/images/dreamcollegepath-logo.jpg" alt="Dream College Path Logo" />
      <div>
        <h1>Dream College Path</h1>
        <p>Empowering Your College Journey</p>
      </div>
    </header>
  );
};

export default Header;